module.exports = __webpack_public_path__ + "static/media/banner.6c89bcb1.jpg";